const ExerciseCard = () => {
  return (
    <>
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
      <ExerciseCardContent />
    </>
  )
}

const ExerciseCardContent = () => {
  return (
    <div className="exercise-card-container">
      <div className="exercise-card-wrapper">
        Exercise Card
      </div>
    </div>
  )
}

export default ExerciseCard;